import { createContext, useState } from "react";
import { TokenDecoded, getTokenDecoded, TOKEN_VAZIO } from "shared/util/tokenFunctions";
import { CondominioContextoDTO, CONDOMINIO_CONTEXTO_VAZIO } from "types/dto/CondominioContextoDTO";
import { useNavigate } from "react-router-dom";
import { Rotas } from "constants/EnumRotas";
import { useGetCondominioContexto } from "hooks/condominio/useGetCondominioContexto";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { converterDataBrParaDate, formatarData } from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { setUsuarioTour } from "hooks/usuario/usuarioTourFuctions";

export type UserContextProps = {
  usuarioLogado: TokenDecoded;
  competenciaSelecionada: Date;
  competenciaSelecionadaOnChange: Date;
  showModalSelecionarCondominioContexto: boolean;
  condominioContexto: CondominioContextoDTO;
  loginContext: () => void;
  logoutContext: () => void;
  alteraUsuarioContexto: () => void;
  alterarCompetencia: (competencia: Date) => void;
  openCloseModalSelecionarCondominioContexto: () => void;
  queryCondominioContexto: string;
  changeQueryCondominioContexto: (query: string) => void;
  alterarCondominioContexto: (condominioContexto: CondominioContextoDTO) => void;
};

let competenciaInicial = new Date();

const INITIAL_STATE_COMPETENCIA = competenciaInicial;
const mesCompetencia = localStorage.getItem("mesCompetencia");
const INITIAL_STATE_COMPETENCIA_ON_CHANGE =
  mesCompetencia !== null ? converterDataBrParaDate(mesCompetencia) : competenciaInicial;

const INITIAL_CONTEXT = {
  usuarioLogado: TOKEN_VAZIO,
  competenciaSelecionada: INITIAL_STATE_COMPETENCIA,
  competenciaSelecionadaOnChange: INITIAL_STATE_COMPETENCIA_ON_CHANGE,
  condominioContexto: CONDOMINIO_CONTEXTO_VAZIO,
  showModalSelecionarCondominioContexto: false,
  loginContext: () => {},
  logoutContext: () => {},
  alteraUsuarioContexto: () => {},
  alterarCompetencia: () => {},
  openCloseModalSelecionarCondominioContexto: () => {},
  queryCondominioContexto: "",
  changeQueryCondominioContexto: () => {},
  alterarCondominioContexto: () => {},
};

export const UserContext = createContext<UserContextProps>(INITIAL_CONTEXT);

export const UserContextProvider = ({ children }: any) => {
  const [usuarioLogado, setUsuarioLogado] = useState(getTokenDecoded());
  const [competenciaSelecionada, setCompetenciaSelecionada] = useState(INITIAL_STATE_COMPETENCIA);
  const [competenciaSelecionadaOnChange, setCompetenciaSelecionadaOnChange] = useState(
    INITIAL_STATE_COMPETENCIA_ON_CHANGE
  );
  const [condominioContexto, setCondominiContexto] = useState<CondominioContextoDTO>(CONDOMINIO_CONTEXTO_VAZIO);
  const [queryCondominioContexto, setQueryCondominioContexto] = useState<string>("");
  const [showModalSelecionarCondominioContexto, setShowModalSelecionarCondominioContexto] = useState(false);
  const { redirectToV1 } = IntegracaoV1();

  const navigate = useNavigate();

  const {} = useGetCondominioContexto(usuarioLogado.condominioContextoId, setCondominiContexto);

  const loginContext = async () => {
    setUsuarioLogado(getTokenDecoded());
    await setUsuarioTour();
    redirectToV1("/");
  };

  const logoutContext = () => {
    localStorage.setItem("jhi-authenticationToken", "");
    setUsuarioLogado(TOKEN_VAZIO);
    navigate(Rotas.LOGIN, { replace: true });
  };

  const alteraUsuarioContexto = () => {
    setUsuarioLogado(getTokenDecoded());
  };

  const alterarCompetencia = (competencia: Date) => {
    localStorage.setItem("mesCompetencia", formatarData(competencia));
    setCompetenciaSelecionada(competencia);
    setCompetenciaSelecionadaOnChange(competencia);
  };

  const openCloseModalSelecionarCondominioContexto = () => {
    setShowModalSelecionarCondominioContexto(!showModalSelecionarCondominioContexto);
  };

  const changeQueryCondominioContexto = (query: string) => {
    setQueryCondominioContexto(query);
  };

  const alterarCondominioContexto = (condominioContexto: CondominioContextoDTO) => {
    setCondominiContexto(condominioContexto);
  };
  return (
    <UserContext.Provider
      value={{
        usuarioLogado,
        competenciaSelecionada,
        competenciaSelecionadaOnChange,
        condominioContexto,
        showModalSelecionarCondominioContexto,
        loginContext,
        logoutContext,
        alteraUsuarioContexto,
        alterarCompetencia,
        openCloseModalSelecionarCondominioContexto,
        queryCondominioContexto,
        changeQueryCondominioContexto,
        alterarCondominioContexto,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
